import YText from "./yText";
export const initDirective = app => {
  app.directive("YText", YText);
};
